import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { endPoints } from './endPoints';
import { queryKeys } from './queryKeys';

export function usePatchContractComment() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (data: {}) => {
      const res = await $api.patch(endPoints.PATCH_COMPANY_COMMENT, { ...data });

      return res.data;
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: [queryKeys.GET_COMPANY_COMMENTS] });
    },
    onError: baseErrorHandler
  });
}
